module.exports = __webpack_public_path__ + "static/media/NotImg.de2a65bb.png";